import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/special_permanent_residence_card_2.png")